import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { ConsentProvider } from './contexts/ConsentContext';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ConsentBanner from './components/ConsentBanner';

// Pages
import Home from './pages/Home';
import Explore from './pages/Explore';
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Disclaimer from './pages/Disclaimer';

// Tool Pages
import QRCodeStudio from './pages/tools/QRCodeStudio';
import Steganography from './pages/tools/Steganography';
import Encryption from './pages/tools/Encryption';
import MetadataRemover from './pages/tools/MetadataRemover';
import SecureVault from './pages/tools/SecureVault';
import FileEncoder from './pages/tools/FileEncoder';
import HashGenerator from './pages/tools/HashGenerator';
import SecureMessages from './pages/tools/SecureMessages';
import PasswordGenerator from './pages/tools/PasswordGeneratorPage';
import PasswordStrength  from './pages/tools/PasswordStrengthPage';
function App() {
  return (
    <ThemeProvider>
      <ConsentProvider>
        <Router>
          <div className="min-h-screen flex flex-col bg-background text-foreground">
            <Navbar />
            <main className="flex-grow">
              <Routes>
              {/* Main Pages */}
              <Route path="/" element={<Home />} />
              <Route path="/explore" element={<Explore />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/disclaimer" element={<Disclaimer />} />
              
              {/* Tool Pages */}
              <Route path="/tools/qr-code-studio" element={<QRCodeStudio />} />
              <Route path="/tools/steganography" element={<Steganography />} />
              <Route path="/tools/encryption" element={<Encryption />} />
              <Route path="/tools/metadata-remover" element={<MetadataRemover />} />
              <Route path="/tools/secure-vault" element={<SecureVault />} />
              <Route path="/tools/file-encoder" element={<FileEncoder />} />
              <Route path="/tools/hash-generator" element={<HashGenerator />} />
              <Route path="/tools/secure-messages" element={<SecureMessages />} />
              <Route path="/tools/password-generator" element={<PasswordGenerator />} />
              <Route path="/tools/password-strength" element={<PasswordStrength />} />  
            </Routes>
          </main>
          <Footer />
          <ConsentBanner />
          <Toaster position="top-right" />
        </div>
      </Router>
    </ConsentProvider>
    </ThemeProvider>
  );
}

export default App;
